const get = require('lodash/object/get');
const actionTypes = require('constants/actionTypes');
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet } = require('utilities/APIRequestHelper');
const { formatText } = require('core/i18n').i18n;
const notification = require('actions/notifications');
const download = require('downloadjs');


const requestDetailsSuccess = (accountId, transactionId, response) => ({
    type: actionTypes.FETCH_ACCOUNT_TRANSACTIONS_DETAILS_SUCCESS,
    payload: {
        accountId,
        transactionId,
        details: get(response, 'listaDetalle.descMovimiento', [])
    }
});

const requestDetailsFailure = (accountId, transactionId, error) => ({
    type: actionTypes.FETCH_ACCOUNT_TRANSACTIONS_DETAILS_FAILURE,
    payload: {
        error,
        accountId,
        transactionId
    }
});

const requestDetailsRequest = (accountId, transactionId) => ({
    type: actionTypes.FETCH_ACCOUNT_TRANSACTIONS_DETAILS_REQUEST,
    payload: {
        accountId,
        transactionId
    }
});

const requestReceiptPreviewSuccess = (accountId, transactionId, preview) => ({
    type: actionTypes.FETCH_RECEIPT_PREVIEW_SUCCESS,
    payload: {
        accountId,
        transactionId,
        preview
    }
});

const requestReceiptPreviewFailure = (accountId, transactionId, error) => ({
    type: actionTypes.FETCH_RECEIPT_PREVIEW_FAILURE,
    payload: {
        error,
        accountId,
        transactionId
    }
});

const requestReceiptPreviewRequest = (accountId, transactionId) => ({
    type: actionTypes.FETCH_RECEIPT_PREVIEW_REQUEST,
    payload: {
        accountId,
        transactionId
    }
});

const requestReceiptDownloadSuccess = (accountId, transactionId) => ({
    type: actionTypes.FETCH_RECEIPT_DOWNLOAD_SUCCESS,
    payload: {
        accountId,
        transactionId
    }
});

const requestReceiptDownloadFailure = (accountId, transactionId, error) => ({
    type: actionTypes.FETCH_RECEIPT_DOWNLOAD_FAILURE,
    payload: {
        error,
        accountId,
        transactionId
    }
});

const requestReceiptDownloadRequest = (accountId, transactionId) => ({
    type: actionTypes.FETCH_RECEIPT_DOWNLOAD_REQUEST,
    payload: {
        accountId,
        transactionId
    }
});

const getReceiptPreview = (accountId, transactionId, dpi = 72) => (dispatch, getState) => {
    const immAccountMovement = getState().accountsTransactions.get(accountId).get('byId').get(transactionId);
    const originCountry = getState().profile.get('originCountry');
    let immAccount = getState().accounts.get('byId').get(accountId);

    if (!immAccount) {
        immAccount = getState().accounts.getIn(['futureAccountsById', accountId]);
    }

    const detailsRequestData = {
        query: {
            codprod: immAccountMovement.get('product'),
            numsor: immAccountMovement.get('contractNumber'),
            centro: immAccountMovement.get('centro'),
            prod: immAccount.get('newProduct'),
            numCont: immAccount.get('newContractNumber'),
            dpiRender: dpi,
            idioma: originCountry
        }
    };

    dispatch(requestReceiptPreviewRequest(accountId, transactionId));
    return APIGet(dispatch, apiURLBuilder.getURL('accountDebitsPreview'), detailsRequestData)
        .then(function(response) {
            dispatch(requestReceiptPreviewSuccess(accountId, transactionId, response.pdfThumbnail));
        }, function(error) {
            dispatch(requestReceiptPreviewFailure(accountId, transactionId, error))
        }
    )
}

const getReceiptDownloading = (accountId, transactionId) => (dispatch, getState) => {
    const immAccountMovement = getState().accountsTransactions.get(accountId).get('byId').get(transactionId);
    let immAccount = getState().accounts.get('byId').get(accountId);
    let originCountry = getState().profile.get('originCountry');

    if (!immAccount) {
        immAccount = getState().accounts.getIn(['futureAccountsById', accountId]);
    }

    if (!immAccountMovement.getIn(['preview', 'downloading'])) {
        const detailsRequestData = {
            query: {
                codprod: immAccountMovement.get('product'),
                numsor: immAccountMovement.get('contractNumber'),
                centro: immAccountMovement.get('centro'),
                prod: immAccount.get('newProduct'),
                numCont: immAccount.get('newContractNumber'),
                idioma: originCountry
            },
            header: {
                responseType: 'arraybuffer'
            }
        };

        dispatch(requestReceiptDownloadRequest(accountId, transactionId));
        return APIGet(dispatch, apiURLBuilder.getURL('accountDebitsPdf'), detailsRequestData)
            .then(response => {
                let accountDebitsPdfName = formatText('accountDebits-pdf') + '.pdf';
                //showFile(response.xhr.response)
                download(response.xhr.response, accountDebitsPdfName, 'application/pdf');
                return dispatch(requestReceiptDownloadSuccess(accountId, transactionId));
            })
            .catch(response => {
                const message = formatText("ReceiptPreview-DownloadError")

                dispatch(notification.error({ message }, { voice: message }));
                dispatch(requestReceiptDownloadFailure(accountId, transactionId, response.error))
            });
    }
}


const getMovementDetails = (accountId, transactionId) => (dispatch, getState) => new Promise(function () {
    const immAccountMovement = getState().accountsTransactions.get(accountId).get('byId').get(transactionId);
    let immAccount = getState().accounts.get('byId').get(accountId);
    if (!immAccount) {
        immAccount = getState().accounts.getIn(['futureAccountsById', accountId]);
    }

    if (!immAccountMovement.get('details').get('hasBeenFetched')){
        const detailsRequestData = {
            query: {
                conexionProducto: immAccount.get('product'),
                conexionNumeroContrato: immAccount.get('contractNumber'),
                producto: immAccount.get('newProduct'),
                numeroContrato: immAccount.get('newContractNumber'),
                codigoMoneda: immAccountMovement.get('balance').get('currency'),
                diaMovimiento: immAccountMovement.get('extra').get('movementNumber'),
                fechaAnotacion: immAccountMovement.get('date'),
                idSituacion: "001",
                codigoIdioma: "E",
                codigoProcedimiento: "BE",
            }
        };

        dispatch(requestDetailsRequest(accountId, transactionId));
        APIGet(dispatch, apiURLBuilder.getURL('accountTransactionDetails'), detailsRequestData)
            .then(function(response) {
                dispatch(requestDetailsSuccess(accountId, transactionId, response));
            }, function(error) {
                dispatch(requestDetailsFailure(accountId, transactionId, error))
            }
        );
    }

});


module.exports = {
    getMovementDetails,
    getReceiptPreview,
    getReceiptDownloading
}
